
import './NuevoQP/Appp.css';
import React from 'react';
import Banner from './NuevoQP/Layout';
import Banner2 from './NuevoQP/Banner2';

function App() {
    return (
        <section
        style={{ width: '100vw', height: '100vh', overflow: 'hidden' }}
        >
            <div className="Appp">
                <Banner/>
               
            </div>
           
        </section>
    );
}

export default App;
